import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CancelEventMutation } from "../graphql/mutations";
import type {
  CancelEventMutationType,
  CancelEventMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCancelEventMutation = (
  options?: MutationHookOptions<
    CancelEventMutationType,
    CancelEventMutationVariablesType
  >
) =>
  useMutation<CancelEventMutationType, CancelEventMutationVariablesType>(
    CancelEventMutation,
    options
  );
